<template>
    <div></div>
</template>

<script>
    import TokenStorage from "../common/TokenStorage";
    import {mapMutations, mapActions} from "vuex";
    import {APP_ID} from "../config";

    export default {
        name: "Auth",
        methods: {
            wxAuthLogin() {
                if (!this.code && TokenStorage.isRefresh()) {
                    window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APP_ID}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`)
                   // this.setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIxMjg3OTQwNTAyNTg1MjYyMDgyIiwiZXhwIjoxNTk2MTYzMTE5fQ.niA4KVjYEadhQiygpSfAq717J_KpLk5BegaxvRPL2Rw');
                } else if (this.code) {
                    const toast = this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0
                    });
                    this.$req.login({
                        code: this.code
                    }).then(({data}) => {
                        this.setToken(data.accessToken);
                        this.getUserInfo().then(() => {
                            toast.clear();
                            this.$router.replace(decodeURIComponent(this.redirect))
                        });
                    });

                }
            },
            ...mapMutations([
                'setToken'
            ]),
            ...mapActions([
                'getUserInfo'
            ])
        },
        props: {
            code: String,
            redirect: String
        },
        mounted() {
            this.wxAuthLogin();
        }
    }
</script>